import { ModelBase } from '../../core/model/model-base';
import { Room } from '../../rent/model/room';
import { DwellingInspection } from './dwelling-inspection';
import { DwellingInspectionPointGroup } from './dwelling-Inspection-point-group';

export enum RoomType {
  Kitchen = 0,
  Bathroom = 1,
  Toilet = 2,
  Bedroom = 3,
  DressingRoom = 4,
  LivingRoom = 5,
  Hall = 6,
  Other = 7,
  Balcony = 8,
  Patio = 9,
}

export function RoomTypeToString(type: RoomType): string {
  switch (type) {
    case RoomType.Bedroom:
      return 'DWELLING_INSPECTION.ROOM.BEDROOM';

    case RoomType.Bathroom:
      return 'DWELLING_INSPECTION.ROOM.BATHROOM';

    case RoomType.DressingRoom:
      return 'DWELLING_INSPECTION.ROOM.DRESSING_ROOM';

    case RoomType.Hall:
      return 'DWELLING_INSPECTION.ROOM.HALL';

    case RoomType.Kitchen:
      return 'DWELLING_INSPECTION.ROOM.KITCHEN';

    case RoomType.LivingRoom:
      return 'DWELLING_INSPECTION.ROOM.LIVING_ROOM';

    case RoomType.Toilet:
      return 'DWELLING_INSPECTION.ROOM.TOILET';

    case RoomType.Other:
      return 'DWELLING_INSPECTION.ROOM.OTHER';

    case RoomType.Patio:
      return 'DWELLING_INSPECTION.ROOM.PATIO';

    case RoomType.Balcony:
      return 'DWELLING_INSPECTION.ROOM.BALCONY';
  }
}

export class DwellingInspectionRoom extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.dwellingInspection = dataContext.dwellingInspection;
      this.pointGroups = Array.isArray(dataContext.pointGroups)
        ? dataContext.pointGroups.map(x => new DwellingInspectionPointGroup(x))
        : [];
      this.type = dataContext.type;
      this.caption = dataContext.caption;
      this.room = dataContext.room;
      this.inspectionOrder = dataContext.inspectionOrder;
      this.area = dataContext.area;
    }
  }
  pointGroups: DwellingInspectionPointGroup[];
  type: RoomType;
  caption: string;
  room: Room | string;
  inspectionOrder: number;
  dwellingInspection: DwellingInspection | string;
  area: number;
}
